module.exports = __webpack_public_path__ + "static/media/bg-square-tiled-2.d213f3d9.png";